/**
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 04.07.2016.
 */

const lhCometMiddleware = function () {

  return function (ref) {

    const dispatch = ref.dispatch;

    return function (next) {

      lh.common.comet.ws.on('message', (data) => {
        let message = JSON.parse(data);

        console.info('WS Event: ', data);

        setTimeout(function () {

          dispatch({type: 'ws-' + message.name, payload: message.payload});
        }, 50);
      });

      return next;
    };
  }
};

export default lhCometMiddleware;


// WEBPACK FOOTER //
// ./src/middlewares/lhCommet/index.js